// extracted by mini-css-extract-plugin
export default {"artists":"Artists_artists__OdCID"};